/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { useEffect } from 'react';
// material
import { DeleteMessage, MultiSelectDropDown } from '@insticator/insticator-ui'; // iui-material
import CreateLabels from 'material/embeds/createlabels/createlabels_container';

// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/controlbar/controlbar_styles';


/* ========== ~~~~~~~~~~ LABELS MANAGEMENT DROPDOWN : CHILD ~~~~~~~~~~ ========== */

const LabelsManagementDropdown = (props) => {
    useEffect(() => {
        props.getLabels(props.accountUUID)
    }, []);

    const handleUpdateLabel = (labelUUID, labelName) => props.updateLabel(labelUUID, labelName);

    const handleDeleteLabel = (labelUUID) =>
        props.displayModal(true, <DeleteMessage itemType={'label'} itemName={props.labels[labelUUID]} primaryAction={() => props.deleteLabel(labelUUID)} />);

    const handleCreateLabels = () => props.displayModal(true, <CreateLabels />);

    return (
        <MultiSelectDropDown
            name={'Labels'}
            title={'All Labels'}
            button={true}
            buttonAction={props.buttonAction}
            icon={`file`}
            onSelect={props.selectLabel}
            searchable={true}
            editable={true}
            onItemUpdate={handleUpdateLabel}
            onItemDelete={handleDeleteLabel}
            onNewItemClick={handleCreateLabels}
            items={Object.keys(props.labels).map(labelUUID => ({ value: labelUUID, name: props.labels[labelUUID] }))}
            selectedItems={props.selectedLabels}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LabelsManagementDropdown);
